import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Container = styled.div`
  position: fixed;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
  max-width: calc(100vw - 32px);
  width: 400px;
`;

export const ToastItem = styled.div<{ $type: 'success' | 'error' | 'warning' | 'info' }>`
  background: ${props => {
    switch (props.$type) {
      case 'success': return '#333';
      case 'error': return '#ef4444';
      case 'warning': return '#f59e0b';
      case 'info': return '#3b82f6';
      default: return '#333';
    }
  }};
  color: white;
  padding: 16px 20px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  animation: ${slideUp} 0.3s ease-out forwards;
  pointer-events: auto;
  min-width: 250px;
`;

export const Icon = styled.span`
  font-size: 1.25rem;
  flex-shrink: 0;
`;

export const Message = styled.span`
  flex: 1;
  line-height: 1.4;
`;
